module.exports = __webpack_public_path__ + "png/icon2.png?0503db3747a2d99c4b8c6d62d9960a59";